import { render } from "./TimeTable.vue?vue&type=template&id=3205f038&scoped=true"
import script from "./TimeTable.vue?vue&type=script&lang=ts"
export * from "./TimeTable.vue?vue&type=script&lang=ts"

import "./TimeTable.vue?vue&type=style&index=0&id=3205f038&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3205f038"

export default script